import React, { useEffect, useRef, useState } from "react";
import { Button } from "@material-ui/core";
import { Get, Post } from "../../../actions/apiActions";
import FloorPlanCanvas from "./FloorPlanCanvas";
import { DayTimeSelection } from "../../settings/components/maxCapacity";
import { AreaList } from "./AreaList";
import { getTranslation } from "../../../heplers/translationHelper";

const TablePlacement = () => {
  const [queryParams, setQueryParams] = useState({
    selectedDate: new Date(),
    dayTime: 0,
    day: new Date().getDay(),
    pageNumber: 0,
    pageSize: 10,
  });
  const [replacementMode, setReplacementMode] = useState(false);
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState();
  
  useEffect(() => {
    fetchAreas();
  }, []);
  const fetchAreas = async () => {
    try {
      await Get(
        { includeClosed: true },
        "TableManagement/GetAllAreas",
        null,
        (response) => {
          setAreas(response.data);
          if(response.data.length && !selectedArea)
            setSelectedArea(response.data[0])
          // const initialTables = {};
          // response.data.forEach((area) => {
          //   initialTables[area.id] = [];
          // });
          // setTables(initialTables);
        },
        (error) => {
          console.error("Error fetching areas:", error);
        }
      );
    } catch (error) {
      console.error("Error fetching areas:", error);
    }
  };
  const handleAddNewArea = async (newAreaName) => {


    const requestBody = {
      title: newAreaName,
      sorting: 1,
    };

    try {
      await Post(
        requestBody,
        "TableManagement/UpsertArea",
        null,
        async (response) => {
          console.log("Area added successfully");
          fetchAreas()
          // const newAreaId = response.data.id;
          // setPositions((prevPositions) => [...prevPositions, { id: newAreaId, title: newPositionName }]);
          // setTables((prevTables) => ({ ...prevTables, [newAreaId]: [] }));
          // setCurrentPosition(newAreaId);
          // setOpenPositionModal(false);
          // setNewPositionName("");
          // setTimeout(() => {
          //   fetchTablesForAllAreas(queryParams.dayTime);
          // }, 500);
        },
        (error) => {
          console.error("Error adding area:", error);
          alert(`${getTranslation("Error adding area")}: ${getTranslation(error?.data?.message || "Unknown error")}`);
        }
      );
    } catch (error) {
      console.error("Error adding area:", error);
    }
  };


  // AreaList already posted DeleteArea: only reload the list
  const handleDeleteArea = (area) => {
    if (selectedArea?.id === area.id) setSelectedArea(undefined);
    fetchAreas();
  };

  const handleToggleArea = (area, isOpen) => {
    Post(
      { id: area.id, isOpen },
      "TableManagement/ToggleArea",
      null,
      () => fetchAreas(),
      (error) => {
        console.error("Error toggling area:", error);
        alert(`${getTranslation("Error")}: ${getTranslation(error?.data || "Unknown error")}`);
      }
    );
  };

  return (
    <div>
      {/* <drawTables/> */}
      {/* <getTableAtPosition/> */}

      <DayTimeSelection params={queryParams} setParams={setQueryParams} />
{/* 
      <div style={{ marginBottom: "10px" }}>
                <Button
                    variant="contained"
                    color={replacementMode ? "secondary" : "primary"}
                    onClick={() => setReplacementMode(!replacementMode)}
                    // disabled={!currentPosition}
                >
                    {replacementMode ? "Disable Replacement Mode" : "Enable Replacement Mode"}
                </Button>
            </div> */}

            <div style={{ display: "flex", alignItems: "flex-start", paddingTop: "18px", overflowX: "auto" }}>
         <AreaList
          areas={areas}
          selectedArea={selectedArea}
          onAreaChange={(newArea)=>setSelectedArea(newArea)}
          onDeleteArea={(area)=>handleDeleteArea(area)}
          onToggleArea={handleToggleArea}
          onAddNewarea={(newAreaName)=>handleAddNewArea(newAreaName)}
          // handleDeletePosition={handleDeletePosition}
          // setOpenPositionModal={setOpenPositionModal}
          // setCurrentPosition={setCurrentPosition}
        />
        <FloorPlanCanvas
          selectedArea={selectedArea}
          dayTime={queryParams}
          enableMove={true}
        />
      </div>

      {/* 

     

      <TableDialog
        open={openBookModal}
        onClose={() => setOpenBookModal(false)}
        title="Book a Table"
        onConfirm={handleBookTable}
        confirmText="Book"
        onDelete={handleDeleteTable}
        deleteText="Delete"
      >
        <TextField
          label="Booking Time"
          type="time"
          value={bookingTime}
          onChange={(e) => setBookingTime(e.target.value)}
          fullWidth
        />
      </TableDialog> */}
    </div>
  );
};

export default TablePlacement;